import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastConfig } from './_classes/toast-config';

@Component({
  selector: 'dc-toast',
  templateUrl: './toast.component.html'
})
export class DCToastComponent implements OnInit {

  @Input() config: ToastConfig;
  @Output() componentDestroy: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {}

  close() {
    this.componentDestroy.emit();
  }
}
